"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExtraLabelListPopover = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactstrap = require("reactstrap");
var _Label = require("../label/Label");
var _templateObject;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ButtonWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n"])));
var ExtraLabelListPopover = exports.ExtraLabelListPopover = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var labels = _ref.labels,
    eventId = _ref.eventId;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    popoverOpen = _useState2[0],
    setPopoverOpen = _useState2[1];
  if (!labels || labels.length === 0) return null;
  var handlePickerButtonClick = function handlePickerButtonClick() {
    setPopoverOpen(!popoverOpen);
  };
  var ExtraLabelButtonStyles = {
    borderRadius: '5px',
    fontSize: '12px',
    textAlign: 'center',
    margin: '2px',
    padding: '2px 8px',
    border: 'none'
  };
  var labelNodes = labels.map(function (label) {
    return /*#__PURE__*/_react["default"].createElement(_Label.Label, (0, _extends2["default"])({
      key: "".concat(eventId).concat(label._id)
    }, label));
  });
  var popoverId = "labels-popover-".concat(eventId, "-row");
  return /*#__PURE__*/_react["default"].createElement(ButtonWrapper, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Button, {
    id: popoverId,
    type: "button",
    style: ExtraLabelButtonStyles
  }, "+".concat(labels.length)), /*#__PURE__*/_react["default"].createElement(_reactstrap.Popover, {
    style: {
      maxHeight: '40vh',
      overflow: 'auto'
    },
    trigger: "focus",
    placement: "bottom",
    isOpen: popoverOpen,
    target: popoverId,
    toggle: handlePickerButtonClick
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.PopoverBody, {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, labelNodes)));
});